import { useEffect } from "react";

import EventsSocket from "../client/Websockets/events";
import client from "../client";
import { AS_ENDPOINT, PROD_ENDPOINT } from "../config/constants";
import { browserLang } from "../config/utils";

export const useAppBootstrap = (initBaseDataUser: () => void) => {
  useEffect(() => {
    const endpoint = window.localStorage.getItem(AS_ENDPOINT) ?? PROD_ENDPOINT;

    EventsSocket.init(endpoint);
    client(endpoint).setLang(browserLang());
    initBaseDataUser();

    return () => {
      EventsSocket.close();
    };
  }, [initBaseDataUser]);
};

